import {Typography} from "../../../../components/Wrappers";
import {Area, AreaChart, ResponsiveContainer} from "recharts"
import React from "react";
import useStyles from "../../styles";
import { useTheme } from "@material-ui/styles";
import Widget from "../../../../components/Widget";

function sum(values){
    return values.reduce((accum, item) => accum + item.value, 0)
}

const CHART_HEIGHT = 40

export default ({stops, vovs, warnings, panics, disables}) => {
    const theme = useTheme()
    const classes = useStyles(theme)
    if (!(stops && vovs && warnings && disables)){
        return ""
    }
    return (
        <Widget
            title="Daily Events Overview"
            className={classes.card}
            bodyClass={classes.fullHeightBody}
            disableWidgetMenu
        >
    <div className={classes.serverOverviewElement}>
        <Typography
            color="text"
            noWrap
            variant={"caption"}
            className={classes.serverOverviewElementText}
        >
            <b>Stops</b><br/>{sum(stops)}
        </Typography>
        <div className={classes.serverOverviewElementChartWrapper}>
            <ResponsiveContainer height={CHART_HEIGHT} width="99%">
                <AreaChart data={stops}>
                    <Area
                        type="monotone"
                        dataKey="value"
                        stroke={theme.series.stop}
                        fill={theme.series.stop}
                        strokeWidth={2}
                        fillOpacity="0.25"
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    </div>
    <div className={classes.serverOverviewElement}>
        <Typography
            color="text"
            noWrap
            variant={"caption"}
            className={classes.serverOverviewElementText}
        >
            <b>VOVs</b><br/>{sum(vovs)}
        </Typography>
        <div className={classes.serverOverviewElementChartWrapper}>
            <ResponsiveContainer height={CHART_HEIGHT} width="99%">
                <AreaChart data={vovs}>
                    <Area
                        type="monotone"
                        dataKey="value"
                        stroke={theme.series.vov}
                        fill={theme.series.vov}
                        strokeWidth={2}
                        fillOpacity="0.25"
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    </div>
            <div className={classes.serverOverviewElement}>
                <Typography
                    color="text"
                    noWrap
                    variant={"caption"}
                    className={classes.serverOverviewElementText}
                >
                    <b>Panics</b><br/>{sum(panics)}
                </Typography>
                <div className={classes.serverOverviewElementChartWrapper}>
                    <ResponsiveContainer height={CHART_HEIGHT} width="99%">
                        <AreaChart data={panics}>
                            <Area
                                type="monotone"
                                dataKey="value"
                                stroke={theme.series.panic}
                                fill={theme.series.panic}
                                strokeWidth={2}
                                fillOpacity="0.25"
                            />
                        </AreaChart>
                    </ResponsiveContainer>
                </div>
            </div>
    <div className={classes.serverOverviewElement}>
        <Typography
            color="text"
            noWrap
            variant={"caption"}
            className={classes.serverOverviewElementText}
        >
            <b>Warnings</b><br/>{sum(warnings)}
        </Typography>
        <div className={classes.serverOverviewElementChartWrapper}>
            <ResponsiveContainer height={CHART_HEIGHT} width="99%">
                <AreaChart data={warnings}>
                    <Area
                        type="monotone"
                        dataKey="value"
                        stroke={theme.series.warning}
                        fill={theme.series.warning}
                        strokeWidth={2}
                        fillOpacity="0.25"
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    </div>
            <div className={classes.serverOverviewElement}>
                <Typography
                    color="text"
                    noWrap
                    variant={"caption"}
                    className={classes.serverOverviewElementText}
                >
                    <b>Disables</b><br/>{sum(disables)}
                </Typography>
                <div className={classes.serverOverviewElementChartWrapper}>
                    <ResponsiveContainer height={CHART_HEIGHT} width="99%">
                        <AreaChart data={disables}>
                            <Area
                                type="monotone"
                                dataKey="value"
                                stroke={theme.series.disable}
                                fill={theme.series.disable}
                                strokeWidth={2}
                                fillOpacity="0.25"
                            />
                        </AreaChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </Widget>
)
}
